var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"ir-module-block",attrs:{"loading":_setup.shareholder_count.loading,"empty":_setup.isEmpty}},[_c(_setup.BarEchartComponent,{attrs:{"xData":_setup.date,"yBarData":_setup.stockholders}}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }